(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bank-registration', {
            parent: 'entity',
            url: '/bank-registration',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.bankRegistration.manageBankRegistration" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bank-registration/bank-registration.html',
                    controller: 'BankRegistrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bankRegistration');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('bank-registration.new', {
            parent: 'bank-registration',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-dialog.html',
                    controller: 'BankRegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('bank-registration.view', {
            parent: 'bank-registration',
            url: '/bank-registration/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['BankRegistration', 'GlobalValues', function(BankRegistration, GlobalValues) {
                                     return BankRegistration.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('bank-registration.edit', {
            parent: 'bank-registration',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-dialog.html',
                    controller: 'BankRegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['BankRegistration', 'GlobalValues', function(BankRegistration, GlobalValues) {
                                     return BankRegistration.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('bank-registration.delete', {
            parent: 'bank-registration',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-delete-dialog.html',
                    controller: 'BankRegistrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BankRegistration', 'GlobalValues', function(BankRegistration, GlobalValues) {
                            return BankRegistration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('bank-registration-todolist', {
            parent: 'dashboard',
            url: '/bankview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('bank-registration-todolist.resubmit', {
            parent: 'dashboard',
            url: '/bankedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-dialog.html',
                    controller: 'BankRegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('bank-registration-auditLog', {
            parent: 'audit-log',
            url: '/bankRegistrationAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('bank-registration-historyReport', {
            parent: 'history-report',
            url: '/bankRegistrationAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        
        
         };
    })();
